export const BRAND_ID = 'DF3C4C78-8C0E-4688-B0A7-A6C4B6A7F988';

